export default __webpack_public_path__ + "static/media/mountain3.c733ca27.png";